import { render, staticRenderFns } from "./NoPaternitySamplesModal.vue?vue&type=template&id=78d6ad16&scoped=true"
import script from "./NoPaternitySamplesModal.vue?vue&type=script&lang=js"
export * from "./NoPaternitySamplesModal.vue?vue&type=script&lang=js"
import style0 from "./NoPaternitySamplesModal.vue?vue&type=style&index=0&id=78d6ad16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d6ad16",
  null
  
)

export default component.exports